import * as R from 'ramda'

//noinspection JSUnusedGlobalSymbols
export default {

    all: state => R.values(state.entities),

    allByFileId: (state, getters) => fileId => {
        return R.filter(R.propEq('file', fileId), getters.all)
    },

    byId: state => id => state.entities[id]

}


